import { ICreateVenueBody } from 'src/api/createVenue';
import { IVenueCreateFormValues } from '../../types';

const formatCreateVenuePayload = ({ name, priceBandId, isTrial }: IVenueCreateFormValues): ICreateVenueBody => {
  return {
    name,
    is_trial: isTrial,
    ...(priceBandId && { price_band_id: priceBandId }),
  };
};

export default formatCreateVenuePayload;
